<template>
  <div class="site-declared-price-wrp ft-12">
    <!-- 顶部批量输入 -->
    <div class="batch-input-row">
      <div class="input-item">
        <span class="label">欧洲站价格：</span>
        <el-input
          v-model="batchPrice.eu"
          placeholder="请输入"
          style="width: 180px"
        />
      </div>
      <div class="input-item">
        <span class="label">美国站价格：</span>
        <el-input
          v-model="batchPrice.us"
          placeholder="请输入"
          style="width: 180px"
        />
      </div>
      <el-button type="primary" @click="batchFill">批量填充</el-button>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      height="400"
      header-cell-class-name="table-header-gray"
    >
      <template v-for="(item, index) in specificationNames">
        <el-table-column
          :key="item.name + index"
          :label="item.name"
          v-if="item.name && item.checked"
          width="100"
        >
          <template slot-scope="{ row }">
            {{ getSpecValue(row, item.name) }} 
          </template>
        </el-table-column>
      </template>
      <el-table-column label="欧洲站价格">
        <template slot-scope="{ row }">
          <el-input-digit
            v-model.number="row.euPrice"
            placeholder="请输入"
            size="small"
            format="#.##"
          />
        </template>
      </el-table-column>
      <el-table-column label="美国站价格">
        <template slot-scope="{ row }">
          <el-input-digit
            v-model.number="row.usPrice"
            placeholder="请输入"
            size="small"
            format="#.##"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'SiteDeclaredPrice',
  model: {
    prop: 'skuList',
    event: 'change',
  },
  props: {
    skuList: {
      type: Array,
      default: () => [],
    },
    // 规格数据（颜色、尺码等）
    specifications: {
      type: Array,
      default: () => [],
    },
    skuSpecificationsKey: {
      type: String,
      default: "skuSpecifications",
    },
  },
  data() {
    return {
      batchPrice: {
        eu: '',
        us: '',
      },
      tableData: [],
    };
  },
  computed:{
    specificationNames() {
      return (this.specifications || []).filter(Boolean).map((item) => ({ name: item.name, checked: !!(item.checked || item.checked === undefined) }));
    },
  },
  watch: {
    skuList: {
      handler(v) {
        this.tableData = cloneDeep(v);
      },
      immediate: true,
      deep: true,
    },
    specifications:{
      handler(v) {
      console.log('specifications:',v)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 批量输入处理
    handleBatchInput() {
      // 可选：实时填充逻辑，如果需要的话
    },
    // 批量填充
    batchFill() {
      let hasValue = false;
      this.tableData.forEach(row => {
        if (this.batchPrice.eu) {
          row.euPrice = this.batchPrice.eu;
          hasValue = true;
        }
        if (this.batchPrice.us) {
          row.usPrice = this.batchPrice.us;
          hasValue = true;
        }
      });

      if (hasValue) {
        this.$emit('input', this.tableData);
        this.$message.success('批量填充成功');
      } else {
        this.$message.warning('请输入要填充的价格');
      }
    },
    getSpecValue(row, name) {
      const skuSpecifications = row[this.skuSpecificationsKey] || []
      const findItem = skuSpecifications.find(item => item.name === name) || {}
      return findItem.value
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.site-declared-price-wrp {
  padding: 10px;

  .batch-input-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    gap: 15px;

    .input-item {
      display: flex;
      align-items: center;
      gap: 8px;

      .label {
        font-size: 12px;
        color: #606266;
        white-space: nowrap;
      }
    }
  }

  ::v-deep .el-table {
    font-size: 12px;

    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }

    .table-header-gray {
      background-color: #f5f7fa !important;
      color: #606266;
      font-weight: 500;
    }
  }
}
</style>
